import { useEffect, useRef } from "react";
import Lottie from "react-lottie-player";

export default function LoadingLottie({
    file,
    style = { width: 50, height: 50 },
    wrapper_style = {},
    text = null,
    text_style = {},
}) {
    const lottieRef = useRef(null);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                ...wrapper_style,
            }}
        >
            <Lottie
                ref={lottieRef}
                animationData={file}
                loop={true}
                play={true}
                style={style}
            />
            {text && <p style={text_style}>{text}</p>}
        </div>
    );
}
